import React, {FC, useEffect} from 'react';
import {UserSuggestion} from "../../models/UserSuggestion";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {UsersService} from "../../service/UsersService";

interface userAutocompleteInterface{
    setUser:Function
}

const UserAutocomplete:FC<userAutocompleteInterface> = ({setUser}) => {
    const [value, setValue] = React.useState<UserSuggestion | null>(null);
    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState<UserSuggestion[]>([]);

    useEffect(()=>{
        async function getCompany(){
            try{
                let newOptions = [] as UserSuggestion[];

                if (value) {
                    newOptions = [value];
                }else {
                    const response=await UsersService.autocompleteUsers(inputValue)
                    response.data.map(item=>{
                        newOptions.push(item);
                    })
                }
                setOptions(newOptions);


            }catch (e) {

            }
        }
        if (inputValue === '') {
            setOptions(value ? [value] : []);
            return undefined;
        }

        getCompany();

    },[value,inputValue])


    return (
        <Autocomplete
            getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
            filterOptions={(x) => x}
            options={options}
            autoComplete
            includeInputInList
            filterSelectedOptions
            noOptionsText={'Пользователь не найден'}
            value={value}
            onChange={(event: any, newValue: UserSuggestion | null) => {
                setOptions(newValue ? [newValue, ...options] : options);
                setValue(newValue);
                setUser(newValue)
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            renderInput={(params) => (
                <TextField {...params} label="Сотрудник" variant="outlined" fullWidth style={{marginBottom:'10px',marginTop:'10px'}}/>
            )}
            renderOption={(option) => {

                return (
                    <Grid container alignItems="center">
                        <Grid item>
                        </Grid>
                        <Grid item xs>
                            <Typography variant="body2">
                                {option.name}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {`${option.cityName}`}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            }}
        />
    );
};

export default UserAutocomplete;